<template>
  <v-card
    outlined
    class="pa-2"
  >
    <span class="text-subtitle-2 text-decoration-underline">{{ title }}</span><br>
    <v-chip
      v-if="softwareChip"
      v-text="body"
      :color="softwareChipColour(softwareDate)"
      :to="softwareLink"
      small
    />
    <span
      v-else
      class="text-body-2"
      v-text="body"
    />
    <v-tooltip
      top
      color="primary"
      v-if="copyTooltip"
    >
      <template v-slot:activator="{ on, attrs }">
        <a id="copyToClipboard" v-on:click.prevent="copyToClipboard(copyValue)" class="text-body-2 px-2">
          <v-icon
            color="primary"
            small
            dark
            v-bind="attrs"
            v-on="on"
          >
            mdi-content-copy
          </v-icon>
        </a>
      </template>
      <span>{{ copyTooltipText }}</span>
    </v-tooltip>
    <v-tooltip
      top
      color="primary"
      v-if="urlTooltip"
    >
      <template v-slot:activator="{ on, attrs }">
        <a id="openInNewTab" :href="`https://${urlValue}`" target="_blank" class="text-body-2 px-2">
          <v-icon
            color="primary"
            small
            dark
            v-bind="attrs"
            v-on="on"
          >
            mdi-open-in-new
          </v-icon>
        </a>
      </template>
      <span>Open URL in new tab</span>
    </v-tooltip>
  </v-card>
</template>

<script>
  export default {
    name: 'DetailsCard',
    props: {
      title: String,
      body: String,
      copyTooltip: Boolean,
      urlTooltip: Boolean,
      copyValue: String,
      urlValue: String,
      copyTooltipText: String,
      softwareChip: Boolean,
      softwareDate: String,
      softwareLink: String,
    },
    methods: {
      copyToClipboard: function (value) {
        navigator.clipboard.writeText(value)
        this.$snackbar.showMessage({ content: 'Copied!', color: 'success', timeout: 5000 })
      },
      softwareChipColour: function (date) {
        // let d = new Date(date)
        let currentDate = new Date()
        let softwareEOLDate = new Date(date)
        let softwareNearEOLDate = new Date(softwareEOLDate.getFullYear(), softwareEOLDate.getMonth() - 6, softwareEOLDate.getDate())

        if (currentDate > softwareEOLDate) {
          return 'error'
        } else if (currentDate > softwareNearEOLDate) {
          return 'warning'
        } else {
          return 'success'
        }
      },
    }
  }
</script>
